<template>
  <div id="order-total" class="order-subtotal clearfix">
    <div class="clearfix">
      <div class="subtotal">
        <div :class="[
          'clearfix',
          totalFee?.grandTotal !== undefined && totalFee.grandTotal !== null
            ? ''
            : 'all-total',
        ]" v-if="totalFee?.subtotal">
          <label>Subtotal:</label>
          <span class="stress">{{ formatCurrency(totalFee!.subtotal) }}</span>
        </div>
        <div class="clearfix" v-for="(total, i) in getTotalFee" :key="i">
          <label>{{ total.Name }}:</label>
          <span style="color: #ff0000">{{ formatCurrency(total.Value) }}</span>
        </div>
        <div class="all-total clearfix" v-if="totalFee?.grandTotal !== undefined && totalFee.grandTotal !== null
          ">
          <label>Grand Total:</label>
          <span class="stress">{{ formatCurrency(totalFee!.grandTotal) }}</span>
        </div>
        <input type="hidden" id="hdHasPay" :a="totalFee?.useFreeSpecSample" />
      </div>
    </div>
    <div class="surprise-gift" style="margin: 5px" v-if="totalFee?.useFreeSpecSample">
      <input id="isVipFreeSpecSample_1" name="isVipFreeSpecSample" value="1" style="margin: 0; vertical-align: middle"
        type="checkbox" :checked="totalFee?.useFreeSpecSample.Checked" @click="onVipFreeSpecSample" />
      <label for="isVipFreeSpecSample_1" style="">Use PLATINUM Pre-Production Credit (up to $100)</label>
    </div>
    <div class="surprise-box" v-if="totalFee?.adminUseFreeSpecSample || totalFee?.adminSurprise">
      <div class="surprise-hd">
        <div class="title">Admin Only</div>
      </div>
      <div class="surprise-bd">
        <div class="surprise-item" v-if="totalFee?.adminUseFreeSpecSample">
          <input id="isFreeSpecSample_2" name="isVipFreeSpecSample" value="2" type="checkbox"
            :checked="totalFee?.adminUseFreeSpecSample.Checked" @click="onAdminFreeSpecSample" /><label
            for="isFreeSpecSample_2">Free Spec,<span class="text">
              free for item &amp; setup (support by vendor)</span></label>
        </div>
        <div class="surprise-item" v-if="totalFee?.adminSurprise">
          <input type="checkbox" id="ckSurprise" name="ck_Surprise" :checked="totalFee?.adminSurprise.Checked"
            @click="onCheckSurprise" value="1" />
          <label for="ckSurprise">
            Surprise Gift,<span class="text">
              free for item &amp; setup &amp; shipping (totally free), and send
              no emails to customers.</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { formatCurrency } from '@anypromo/shared/utils/helper'
import { computed, defineComponent, type PropType } from 'vue'
import { type TotalFee } from '../types'

export default defineComponent({
  props: {
    totalFee: {
      type: Object as PropType<TotalFee>,
      default: () => {
        return {}
      }
    }
  },
  emits: {
    setVipFreeSpecSampe: (val: boolean) => true,
    setAdminFreeSpecSample: (val: boolean) => true,
    setSurprise: (val: boolean) => true
  },
  setup (props, { emit }) {
    const onVipFreeSpecSample = (ev: MouseEvent) => {
      const target = ev.target as HTMLInputElement
      emit('setVipFreeSpecSampe', target.checked)
    }

    const getTotalFee = computed(() => props.totalFee && props.totalFee.totalFee ?
      props.totalFee.totalFee.filter(f => f.Name !== 'Rush Per Order' && f.Name !== 'Rush Production' && f.Name !== 'Spec Sample Fee')
      : [])

    const onAdminFreeSpecSample = (ev: MouseEvent) => {
      const target = ev.target as HTMLInputElement
      emit('setAdminFreeSpecSample', target.checked)
    }

    const onCheckSurprise = (ev: MouseEvent) => {
      const target = ev.target as HTMLInputElement
      emit('setSurprise', target.checked)
      // checkSurprise({ isSurprise: target.checked ? 1 : 0 }).then((f) => {});
    }
    return {
      formatCurrency,
      getTotalFee,
      onVipFreeSpecSample,
      onAdminFreeSpecSample,
      onCheckSurprise
    }
  }
})
</script>
<style lang="less">
  .surprise-gift {
    label {
      margin-bottom: 0px;
      padding-left: 3px;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
    }
  }
</style>
